// copied from private\ads-studio\packages\ads-studio-app-components\src\page-components\edit-image-page-component\style.js
// edit as necessary
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  videoEditor: {
    width: '1280px',
    top: '60px',
    overFlowY: 'hidden',
    '& .fui-DrawerBody': {
      paddingLeft: '0px',
      paddingRight: '0px',
    },
  },
  editVideoPage: {
    display: 'flex',
    backgroundColor: '#F0F0F0',
  },
  navigationView: {
    width: '85px',
    borderWidth: '2px',
  },
  actionsWrapperContent: {
    marginLeft: '5px',
    marginRight: '5px',
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  actionsWrapper: {
    minWidth: '300px',
    maxWidth: '300px',
    height: 'auto',
    paddingBottom: '110px',
    marginTop: '10px',
    marginBottom: '12px',
    boxShadow: '0px 0px 2px 0px #0000001F',
    borderRadius: '10px',
    backgroundColor: '#FFFFFF',
    ...shorthands.overflow('hidden'),
    position: 'relative',
  },
  previewContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
    overflowY: 'auto',
    position: 'relative',
    ...shorthands.padding(tokens.spacingHorizontalM),
  },
  scenePreview: {
    width: '100%',
    flexGrow: 1,
  },
  storyBoardContainer: {
    paddingTop: '10px',
    width: '100%',
    height: '270px',
  },
  leftPanelTop: {
    paddingTop: '10px',
  },
  bottom: {
    '& .apply-button': {
      marginRight: '8px',
    },
    '& .cancel-button': {
      marginRight: '8px',
    },
  },
  containerWrapper: {
    height: '100%',
    paddingLeft: '0px',
    paddingRight: '0px',
  },
  actionBarFooter: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
  },
  generateButtonContainer: {
    width: '100%',
    display: 'flex',
  },
  generateButton: {
    marginTop: '10px',
    marginBottom: '10px',
    marginRight: '20px',
    marginLeft: '20px',
    width: '100%',
    flexGrow: '1',
  },
  topNavigationParent: {
    marginLeft: '10px',
    marginRight: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingLeft: '5px',
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
  },
  topNavigationLeft: {
    textAlign: 'left',
    alignContent: 'center',
  },
  topNavigationRight: {
    textAlign: 'right',
  },
});
